import { Controller } from "@hotwired/stimulus"

// Owns one iteration's conditions editor: a list of attribute/operator/values
// rows submitted together as the iteration's condition array. "Add condition"
// clones a hidden template row (renumbering its array index); "remove" deletes a
// row, reindexes the survivors to a dense 0..n array and submits so the preview
// re-runs. A debounced submit fires while typing the values field.
export default class extends Controller {
  static targets = ["list", "rowTemplate"]
  static values = { debounce: { type: Number, default: 500 } }

  initialize() {
    this.debounceTimer = null
  }

  disconnect() {
    clearTimeout(this.debounceTimer)
  }

  addRow(event) {
    event.preventDefault()
    const index = this.listTarget.children.length
    const html = this.rowTemplateTarget.innerHTML.replaceAll("NEW_INDEX", index)
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  removeRow(event) {
    event.preventDefault()
    event.target.closest("[data-condition-row]").remove()
    this.reindex()
    this.submit()
  }

  schedule() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.submit(), this.debounceValue)
  }

  submit() {
    clearTimeout(this.debounceTimer)
    // The controller root is the wrapper <div>; submit the <form> inside it.
    this.element.querySelector("form").requestSubmit()
  }

  reindex() {
    this.listTarget.querySelectorAll("[data-condition-row]").forEach((row, i) => {
      row.querySelectorAll("[name]").forEach((field) => {
        field.name = field.name.replace(/\[conditions\]\[\d+\]/, `[conditions][${i}]`)
      })
    })
  }
}
